import { useEffect, useState } from "react";

import {
  MessageStatus,
  ReduxMessage,
} from "../../store/reducers/messageListReducer";
import BellMuted from "../icons/BellMuted";
import IosAvatar from "../ios/IosAvatar";

import { NOTIFICATION_LEVEL } from "../../constants";
import { SetSidType, SetUnreadMessagesType } from "../../types";
import { getMessageStatus } from "../../api";
import { formatPhoneNumber } from "../../utils/displayName";
import { listTime } from "../../utils/iosTime";

import { ReduxConversation } from "../../store/reducers/convoReducer";
import { ReduxParticipant } from "../../store/reducers/participantsReducer";

interface SingleConvoProps {
  convoId: string;
  setSid: SetSidType;
  currentConvoSid: string;
  lastMessage: string;
  myMessage: ReduxMessage | false;
  unreadMessagesCount: number;
  convo: ReduxConversation;
  updateUnreadMessages: SetUnreadMessagesType;
  onClick: () => void;
  participants: ReduxParticipant[];
  messages: ReduxMessage[];
  typingInfo: string[];
  use24hTimeFormat: boolean;
}

const ConversationView: React.FC<SingleConvoProps> = (
  props: SingleConvoProps
) => {
  const { convo, convoId, myMessage, lastMessage, unreadMessagesCount } = props;
  const displayName = formatPhoneNumber(convo.friendlyName ?? convo.sid);
  const muted = convo.notificationLevel === NOTIFICATION_LEVEL.MUTED;
  const selected = props.currentConvoSid === convo.sid;

  const [lastMsgStatus, setLastMsgStatus] = useState("");
  const lastDate = props.messages?.length
    ? props.messages[props.messages.length - 1].dateCreated
    : null;
  const time = lastDate ? listTime(lastDate, props.use24hTimeFormat) : "";

  useEffect(() => {
    if (!myMessage || props.typingInfo.length) {
      setLastMsgStatus("");
      return;
    }
    getMessageStatus(myMessage, props.participants).then((statuses) => {
      if (statuses[MessageStatus.Read]) {
        setLastMsgStatus(MessageStatus.Read);
      } else if (statuses[MessageStatus.Delivered]) {
        setLastMsgStatus(MessageStatus.Delivered);
      } else if (statuses[MessageStatus.Failed]) {
        setLastMsgStatus(MessageStatus.Failed);
      } else if (statuses[MessageStatus.Sending]) {
        setLastMsgStatus(MessageStatus.Sending);
      }
    });
  }, [convo, myMessage, lastMessage, props.participants, props.typingInfo]);

  const failed = lastMsgStatus === MessageStatus.Failed;

  return (
    <div
      id={convoId}
      className={`ios-row name${selected ? " selected" : ""}`}
      onClick={props.onClick}
      role="button"
      aria-current={selected}
    >
      <span
        className={`ios-unread-dot${
          unreadMessagesCount > 0 && !muted ? " visible" : ""
        }`}
        title={unreadMessagesCount > 0 ? `${unreadMessagesCount} unread` : ""}
      />
      <IosAvatar name={displayName} size={44} />
      <div className="ios-row-main">
        <div className="ios-row-top">
          <span className="ios-row-name">
            {displayName}
            {muted ? <BellMuted /> : null}
          </span>
          <span className="ios-row-time">{time}</span>
        </div>
        <div className={`ios-row-preview${failed ? " failed" : ""}`}>
          {failed ? "Not Delivered" : lastMessage}
        </div>
      </div>
    </div>
  );
};

export default ConversationView;
